module.exports = __webpack_public_path__ + "img/FAQ_Asset.618d7127.png";